import {css} from '@yandex-delivery/blocks/theme/css'
import {theme} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  root: css`
    position: fixed;
    width: ${theme.spacing(50)}px;
    max-height: calc(100vh - ${theme.spacing(13)}px);
    top: ${theme.spacing(11)}px;
    left: ${theme.spacing(2)}px;
    background-color: var(--colorScheme-bgMinor, #f5f4f2);
    border-radius: ${theme.spacing(3)}px;
    box-sizing: border-box;
    box-shadow: 0 5px 40px rgb(0 0 0 / 25%);
    overflow-x: hidden;
    /* Disable scrollbar */
    overflow-y: scroll;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
      display: none;
    }

    [dir='rtl'] & {
      left: auto;
      right: ${theme.spacing(2)}px;
    }
  `,
  section: css`
    background-color: var(--colorScheme-background, #ffffff);
    border-radius: ${theme.spacing(3)}px;
    box-sizing: border-box;
    margin-bottom: ${theme.spacing(1)}px;
  `,
  scrollable: css`
    overflow: visible !important;
  `,
  fullHeight: css`
    margin-bottom: 0;
  `,
}
